import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Location } from 'history';

import reportError from 'ha/helpers/bugsnag/reportError';
import { replaceLocation } from 'ha/modules/URLLocationHandler';
import { Thunk } from 'ha/myredux/types';
import { getLocalisedLocation } from '../selectors';
import { GlobalState } from 'ha/types/store';

export const enum ActionTypes {
  START = 'LANGUAGE_SWITCHER/CHANGE_LANGUAGE_START',
}

export const Actions = {
  start: (nextLanguage: string) =>
    createAction(ActionTypes.START, nextLanguage, {
      analytics: {
        type: 'Set different language',
        payload: {
          language: nextLanguage,
        },
      },
    }),
};

export type Actions = ActionsUnion<typeof Actions>;

const changeLanguage = (
  nextLanguageCode: string,
  currentLocation: Location,
  isAuthenticated: boolean,
): Thunk<GlobalState> => (dispatch, getState, { apiV2 }) => {
  dispatch(Actions.start(nextLanguageCode));

  const promise = isAuthenticated
    ? apiV2
        .updateUser('me', {
          lang: nextLanguageCode,
        })
        .catch((error: Error) => {
          reportError('Change Language Error', { metaData: { error } });
        })
    : Promise.resolve();

  return promise.then(() => {
    const state = getState();

    dispatch(
      replaceLocation(
        getLocalisedLocation(state, nextLanguageCode, currentLocation),
      ),
    );
  });
};

export default changeLanguage;
